import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/gate/page.tsx");
